// extracted by mini-css-extract-plugin
export var modal = "_gx-0";